import { useState } from "react"
import {addItems, IncrementItems, DecrementItems} from "../store/CartSlicer"
import { useDispatch, useSelector } from "react-redux";

export default function RestInfo({restData}){



  const dispatch = useDispatch();
  const items = useSelector(state=>state.cartslice.items);

  const element = items.find(item=>item.id===restData.id);
  const count = element? element.quantity:0;

  function handleAdditems(){
    dispatch(addItems(restData));
  }

  function handleIncrementItems(){
    dispatch(IncrementItems(restData));
  }

  function handleDecrementItems(){
    dispatch(DecrementItems(restData));
  }

    return (
         <>
        <div className="flex w-full justify-between mb-2 pb-2">
          <div className="w-[70%]">
            <p className="text-xl text-charcoal font-semibold mb-1">{restData?.name}</p>
            <p className="text-lg font-mono text-charcoal/80">{"₹"+ ("defaultPrice" in restData ? restData?.defaultPrice/100:restData?.price/100)}</p>
            {
                restData?.ratings?.aggregatedRating?.rating &&
                <>
                    <span className="text-curry font-mono">{restData.ratings.aggregatedRating.rating}</span>
                    <span className="text-charcoal/50 font-mono"> ({restData.ratings.aggregatedRating.ratingCountV2 ?? 0})</span>
                </>
            }
            <p className="text-charcoal/70">
                {restData?.description}
            </p>
          </div>
          <div className="w-[20%] relative h-42">
            <img className="w-60 h-36 object-cover rounded-2xl" alt={restData?.name || "Dish"} src={"https://media-assets.swiggy.com/swiggy/image/upload/"+restData.imageId}></img>
          {
            (count==0)?(<button className="absolute bottom-1 left-20 rounded-xl text-lg font-medium text-ember px-6 py-2 shadow-md border border-charcoal/10 bg-cream" onClick={()=>handleAdditems()}>ADD</button>):(
              <div className="absolute bottom-1 left-20 flex gap-3 text-lg text-ember px-6 py-2 shadow-md border border-charcoal/10 bg-cream rounded-2xl">
                <button onClick={()=>handleDecrementItems()}>-</button>
                <span className="font-mono">{count}</span>
                <button onClick={()=> handleIncrementItems()}>+</button>
              </div>
            )
          }
          </div>
        </div>
        <hr className="mb-6 mt-2 border-charcoal/15"></hr>
        </>

    )
}